import { render, staticRenderFns } from "./c-treeview-data-table.vue?vue&type=template&id=31c1439f&scoped=true&"
import script from "./c-treeview-data-table.vue?vue&type=script&lang=js&"
export * from "./c-treeview-data-table.vue?vue&type=script&lang=js&"
import style0 from "./c-treeview-data-table.vue?vue&type=style&index=0&id=31c1439f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c1439f",
  null
  
)

export default component.exports